import ThemeToggle from './ThemeToggle';
import NumberFormatToggle from './NumberFormatToggle';

// Theme + number-format switches. `floating` pins them to the top-right of standalone screens.
export default function DisplayToggles({ floating = false }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      ...(floating ? { position: 'fixed', top: 16, right: 16, zIndex: 50 } : {}),
    }}>
      <NumberFormatToggle />
      <ThemeToggle />
    </div>
  );
}
